export type ResponseFormHandle = {
    save: () => Promise<void>;
    submit: () => Promise<string[]>;
};

const flattenErrors = (errors: unknown): string[] => {
    if (typeof errors === 'string') return errors.trim() ? [errors] : [];
    if (Array.isArray(errors)) return errors.flatMap(flattenErrors);
    if (errors && typeof errors === 'object') return Object.values(errors).flatMap(flattenErrors);
    return [];
};

/**
 * Every message in a Formik error tree, flattened and de-duplicated.
 *
 * The tree mirrors the form's shape - nested objects for `screeningDetails`, arrays for the
 * additional-information entries - and one rule firing on several entries repeats its message, so
 * the same text would otherwise be listed more than once. Blank entries are dropped: a schema rule
 * that reports through `createError` on another path leaves an empty message behind.
 */
export const collectFormErrors = (errors: unknown): string[] => Array.from(new Set(flattenErrors(errors)));
